export const prerender = true;
export const ssr = true;

import { browser } from '$app/environment';

import type { Load } from '@sveltejs/kit';

import { loadTranslations, defaultLocale } from '$lib/i18n/translations';
import languages from '$i18n/languages.json';
import { setLanguage, type language } from '$lib/i18n/locale';

const supportedLocales = Object.keys(languages);
export const load: Load = async (event) => {
  if(!browser) return {};
  const { pathname } = event.url;
  
  // 如果没有可接受的语言或不支持，使用默认语言
  let userPreferredLocale = defaultLocale;
  // 如果是根目录，则获取系统默认接收语言
  if(pathname === '/' ) {
    const acceptLanuage = navigator?.language || defaultLocale as language;
    if(['zh-HK','zh-MO','zh-TW'].includes(acceptLanuage)){
        userPreferredLocale = 'zh-TW';
    }
    else if(supportedLocales.includes(acceptLanuage)){
        userPreferredLocale=acceptLanuage
    }
    else if(supportedLocales.includes(acceptLanuage.split('-')[0])){
        userPreferredLocale=acceptLanuage.split('-')[0]
    }
  }else{
    // 否则，从路径中获取
      const [, maybeLocale] = pathname.split('/');
      if (supportedLocales.includes(maybeLocale)) {
          userPreferredLocale = maybeLocale;
      }
  }
  document.documentElement.lang = userPreferredLocale;
  // 设置语言
  setLanguage(userPreferredLocale as language)
  await loadTranslations(userPreferredLocale, pathname);
  return {};
}